export default "__VITE_ASSET__1bac49d3__"